// import node module libraries
import { Fragment, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import {
	ListGroup,
	Accordion,
	Card,
	Image,
	Badge,
	useAccordionButton,
	AccordionContext
} from 'react-bootstrap';

// import simple bar scrolling used for notification item scrolling
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';

// import media files
import InverseLogo from 'assets/images/brand/logo/logo.svg';

// import routes file
import { DashboardMenu } from 'routes/dashboard/DashboardRoutes';
import RoleBasedGuard from 'guards/RoleGuard';

const NavbarVertical = (props) => {
	const location = useLocation();

	const CustomToggle = ({ children, eventKey, icon }) => {
		const { activeEventKey } = useContext(AccordionContext);
		const decoratedOnClick = useAccordionButton(eventKey, () =>
			console.log('Event Key : ' + eventKey)
		);
		const isCurrentEventKey = activeEventKey === eventKey;
		return (
			<li className="nav-item">
				<Link
					className="nav-link"
					onClick={decoratedOnClick}
					to="#!"
					data-bs-toggle="collapse"
					data-bs-target="#navDashboard"
					aria-expanded={isCurrentEventKey ? true : false}
					aria-controls="navDashboard"
				>
					{icon ? <i className={`nav-icon fe fe-${icon} me-2`}></i> : ''}{' '}
					{children}
				</Link>
			</li>
		);
	};

	const generateLink = (item) => {
		return (
			<Link
				className={`nav-link ${location.pathname === item.link ? 'active' : ''
					}`}
				to={item.link}
				onClick={(e) =>
					isMobile ? props.onClick(!props.showMenu) : props.showMenu
				}
			>
				{item.name}
				{''}
				{item.badge ? (
					<Badge
						className="ms-1"
						bg={item.badgecolor ? item.badgecolor : 'primary'}
					>
						{item.badge}
					</Badge>
				) : (
					''
				)}
			</Link>
		);
	};

	const isMobile = useMediaQuery({ maxWidth: 767 });

	return (
		<Fragment>
			<SimpleBar style={{ maxHeight: '100vh' }} className="modern-sidebar">
				<div className="nav-scroller">
					<Link className="navbar-brand-modern" to="/">
						<Image src={InverseLogo} alt="Logo" className="logo-img" />
					</Link>
				</div>
				{/* Dashboard Menu */}
				<Accordion
					defaultActiveKey="0"
					as="ul"
					className="navbar-nav flex-column modern-nav"
				>
					{DashboardMenu.map(function (menu, index) {
						if (menu.grouptitle) {
							return (
								<Card bsPrefix="nav-item" key={index + 'group'}>
									{/* group title item */}
									<div className="navbar-heading-modern">{menu.title}</div>
									{/* end of group title item */}
								</Card>
							);
						} else {
							if (menu.children) {
								return (
									<Fragment key={index + menu.title}>
										{/* main menu / menu level 1 / root items */}
										<RoleBasedGuard roles={menu.roles}>
											<CustomToggle eventKey={menu.id} icon={menu.icon}>
												{menu.title}
												{menu.badge ? (
													<Badge
														className="ms-1 modern-badge"
														bg={menu.badgecolor ? menu.badgecolor : 'primary'}
													>
														{menu.badge}
													</Badge>
												) : (
													''
												)}
											</CustomToggle>
											<Accordion.Collapse
												eventKey={menu.id}
												as="li"
												bsPrefix="nav-item"
											>
												<Accordion className="navbar-nav flex-column" as="ul">
													<ListGroup
														as="ul"
														bsPrefix=""
														className="nav flex-column"
													>
														{menu.children.map(function (
															menuItem,
															menuItemIndex
														) {
															if (menuItem.children) {
																return (
																	<Fragment key={menuItemIndex}>
																		{/* second level with children */}
																		<CustomToggle eventKey={menuItem.id}>
																			{menuItem.title}
																			{menuItem.badge ? (
																				<Badge
																					className="ms-1 modern-badge"
																					bg={
																						menuItem.badgecolor
																							? menuItem.badgecolor
																							: 'primary'
																					}
																				>
																					{menuItem.badge}
																				</Badge>
																			) : (
																				''
																			)}
																		</CustomToggle>
																		<Accordion.Collapse
																			eventKey={menuItem.id}
																			bsPrefix="nav-item"
																			as="li"
																		>
																			<Accordion
																				className="navbar-nav flex-column"
																				as="ul"
																			>
																				<ListGroup
																					as="ul"
																					bsPrefix=""
																					className="nav flex-column"
																				>
																					{/* third level menu started  */}
																					{menuItem.children.map(function (
																						subMenuItem,
																						subMenuItemIndex
																					) {
																						return subMenuItem.children ? (
																							<Fragment key={subMenuItemIndex + subMenuItem.title}>
																								<CustomToggle
																									eventKey={subMenuItem.id}
																								>
																									{subMenuItem.title}
																									{subMenuItem.badge ? (
																										<Badge
																											className="ms-1 modern-badge"
																											bg={
																												subMenuItem.badgecolor
																													? subMenuItem.badgecolor
																													: 'primary'
																											}
																										>
																											{subMenuItem.badge}
																										</Badge>
																									) : (
																										''
																									)}
																								</CustomToggle>
																								<Accordion.Collapse
																									eventKey={subMenuItem.id}
																									bsPrefix="nav-item"
																									as="li"
																								>
																									<ListGroup
																										as="ul"
																										bsPrefix=""
																										className="nav flex-column"
																									>
																										{subMenuItem.children.map(
																											function (
																												thirdLevelItem,
																												thirdLevelItemIndex
																											) {
																												return (
																													<ListGroup.Item
																														key={
																															thirdLevelItemIndex + thirdLevelItem.title
																														}
																														as="li"
																														bsPrefix="nav-item"
																													>
																														{/* third level with children */}
																														{generateLink(
																															thirdLevelItem
																														)}
																													</ListGroup.Item>
																												);
																											}
																										)}
																									</ListGroup>
																								</Accordion.Collapse>
																							</Fragment>
																						) : (
																							<ListGroup.Item
																								key={subMenuItemIndex}
																								as="li"
																								bsPrefix="nav-item"
																							>
																								{/* third level without children */}
																								{generateLink(subMenuItem)}
																							</ListGroup.Item>
																						);
																					})}
																					{/* end of third level menu  */}
																				</ListGroup>
																			</Accordion>
																		</Accordion.Collapse>
																		{/* end of second level with children */}
																	</Fragment>
																);
															} else {
																return (
																	<ListGroup.Item
																		as="li"
																		bsPrefix="nav-item"
																		key={menuItemIndex}
																	>
																		{/* second level without children */}
																		{generateLink(menuItem)}
																		{/* end of second level without children  */}
																	</ListGroup.Item>
																);
															}
														})}
													</ListGroup>
												</Accordion>
											</Accordion.Collapse>
										</RoleBasedGuard>

										{/* end of main menu / menu level 1 / root items */}
									</Fragment>
								);
							} else {
								return (
									<Card bsPrefix="nav-item" key={index}>
										{/* menu item without any childern items like Help Center, Documentation and Changelog items*/}
										<Link
											to={menu.link}
											className={`nav-link ${location.pathname === menu.link ? 'active' : ''
												}`}
										>
											{typeof menu.icon === 'string' ? (
												<i className={`nav-icon fe fe-${menu.icon} me-2`}></i>
											) : (
												menu.icon
											)}
											{menu.title}
											{menu.badge ? (
												<Badge
													className="ms-1 modern-badge"
													bg={menu.badgecolor ? menu.badgecolor : 'primary'}
												>
													{menu.badge}
												</Badge>
											) : (
												''
											)}
										</Link>
										{/* end of menu item without any childern items */}
									</Card>
								);
							}
						}
					})}
				</Accordion>
				{/* end of Dashboard Menu */}
			</SimpleBar>

			<style jsx global>{`
				/* Modern Sidebar Styles */
				.modern-sidebar {
					background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
				}

				.navbar-brand-modern {
					display: flex;
					align-items: center;
					justify-content: center;
					padding: 1.5rem 1rem;
					margin-bottom: 1rem;
					border-bottom: 1px solid rgba(255, 255, 255, 0.1);
				}

				.logo-img {
					max-height: 40px;
					filter: brightness(0) invert(1);
				}

				/* Group Headings */
				.navbar-heading-modern {
					font-size: 0.75rem;
					font-weight: 700;
					text-transform: uppercase;
					letter-spacing: 1px;
					color: rgba(255, 255, 255, 0.5);
					padding: 1.5rem 1.5rem 0.75rem;
					margin-top: 1rem;
				}

				/* Nav Items */
				.modern-nav .nav-item {
					margin-bottom: 0.25rem;
				}

				.modern-nav .nav-link {
					display: flex;
					align-items: center;
					padding: 0.75rem 1.25rem;
					color: #475569;
					font-size: 0.9375rem;
					font-weight: 500;
					transition: all 0.2s ease;
					border-left: 3px solid transparent;
				}

				.modern-nav .nav-link:hover {
					background: rgba(246, 133, 33, 0.1);
					color: #F68521;
					transform: translateX(4px);
				}

				.modern-nav .nav-link.active {
					background: linear-gradient(135deg, #F68521 0%, #1d9eb0 100%);
					color: white;
					font-weight: 600;
					box-shadow: 0 4px 12px rgba(246, 133, 33, 0.3);
				}

				.modern-nav .nav-link.active::before {
					content: '';
					position: absolute;
					left: 0;
					top: 50%;
					transform: translateY(-50%);
					width: 4px;
					height: 60%;
					background: white;
					border-radius: 0 4px 4px 0;
				}

				/* Icons */
				.nav-icon {
					font-size: 1.125rem;
					width: 20px;
					text-align: center;
				}

				/* Badges */
				.modern-badge {
					padding: 4px 8px;
					border-radius: 6px;
					font-size: 0.6875rem;
					font-weight: 700;
					margin-left: auto;
				}

				/* Nested Items */
				.modern-nav .nav .nav-item .nav-link {
					padding-left: 3rem;
					font-size: 0.875rem;
				}

				.modern-nav .nav .nav .nav-item .nav-link {
					padding-left: 4rem;
					font-size: 0.8125rem;
				}

				/* Accordion Transitions */
				.accordion-collapse {
					transition: height 0.3s ease;
				}

				/* Scrollbar Styling */
				.modern-sidebar .simplebar-track.simplebar-vertical {
					background: rgba(255, 255, 255, 0.05);
					border-radius: 4px;
					width: 6px;
					right: 4px;
				}

				.modern-sidebar .simplebar-scrollbar::before {
					background: rgba(246, 133, 33, 0.5);
					border-radius: 4px;
				}

				.modern-sidebar .simplebar-scrollbar.simplebar-visible::before {
					opacity: 1;
				}

				/* Responsive */
				@media (max-width: 767px) {
					.navbar-heading-modern {
						padding: 1rem 1rem 0.5rem;
					}

					.modern-nav .nav-link {
						padding: 0.75rem 1rem;
						margin: 0 0.5rem;
					}
				}
			`}</style>
		</Fragment>
	);
};

export default NavbarVertical;